<template>
    <el-container style="height: 100vh">
        <el-main class="page-not-found-content--center">
            <el-row justify="center"
                    type="flex"
                    align="middle">
                <el-col :span="24"
                        :xs="24"
                        :sm="12"
                        :md="12"
                        :lg="6">
                    <el-card shadow="always">
                        <el-row type="flex"
                                justify="center"
                                align="middle">
                            <logo-home home-color="#aaa"
                                       text-color="#aaa" />
                        </el-row>
                        <el-row align="middle"
                                justify="center"
                                class="text--center">
                            <el-col class="display-4 text-color--gradient">
                                {{ code }}
                            </el-col>
                            <el-col>{{ message }}</el-col>
                            <el-col>
                                <el-button type="primary"
                                           @click="goToMainPage">
                                    Вернуться на главную
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-card>
                </el-col>
            </el-row>
        </el-main>
    </el-container>
</template>
<script>
import LogoHome from '@/components/icons/header/LogoHome';

export default {
  name: 'ErrorPage',
  components: {LogoHome},
  props: {
    code: {
      type: String,
      default: '404'
    },
    message: {
      type: String,
      default: 'Эта страница не может быть найдена'
    }
  },
  data: () => ({}),
  methods: {
    goToMainPage() {
      this.$router.push({name: 'projects'});
    }
  }

};
</script>
<style lang="scss"
       scoped>
.page-not-found-content--center {
  display: flex;
  align-content: center;

  .el-row--flex {
    flex: 1;
    margin-bottom: 16px;

    .el-col {
      margin-bottom: 16px;
    }
  }
}
</style>
